import { produce } from 'immer';
import { SET_LAYER_ARTIFACTS } from './actions';

export const defaultState = {
    onOverlayClick: undefined
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_LAYER_ARTIFACTS:
        case SET_LAYER_ARTIFACTS + reducerSuffix: {
            Object.assign(draftState, {
                ...action.payload
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
